import styled, {css} from "styled-components"

import Icon from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {Card} from "@irati/ui/src/Layout"

interface Props {
  bgColor: string
}

interface WrapperProps {
  color?: string
}

export const StyledIcon = styled(Icon)<Props>`
  width: 20px;
  path:last-child {
    fill: ${({bgColor}) => bgColor};
  }
`

export const StyledCard = styled(Card)`
  width: 100%;
`

export const IconWrapper = styled(Flex)<WrapperProps>`
  width: 20px;
  height: 20px;
  background: ${({theme, color}) => color || theme.colors.greys.black};
  border-radius: 100%;
  margin-top: 2px;
`

export const ButtonWrapper = styled(Flex)`
  ${({theme}) => css`
    min-width: 50px;
    ${theme.mediaQueries.maxWidthMedia.tablet`
      min-width: 20px;
    `}
  `}
`
